import {filterSvg as Icon__small__filterSvg} from '../Icon__small/Icon__small--filter.js';

export var filter = {
  name: 'filter',
  category: 'icon',
  colorable: true,
  svg: Icon__small__filterSvg,
};
